import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { Box } from 'app/components/basic/Wrappers/Box';
import { Button } from 'app/components/BasicButtons/Button';
import clsx from 'clsx';
import { H3 } from 'app/components/Typography';
import { BasicTable, HeaderColumn, HeaderColumnPicker } from './Table';
import { useTranslation } from 'react-i18next';
import { translations } from 'locales/translations';
import { Body } from 'app/components/Typography';
import { IconButton } from 'app/components/BasicButtons/IconButton';
import { Icon } from 'app/components/BasicIcons/FontAwesome';
import { ImprotData } from '../Data';
import { Entity } from 'types/common';
import { BasicToggle } from 'app/components/BasicToggle';
//import { ImportColumn } from '../Actions/Types';
//import { ValuePicker } from './ValuePicker';

export const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      height: '100%',
    },
    titleContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: '0px',
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(3),
      top: theme.spacing(3),
      color: theme.palette.grey[500],
    },
    container: {
      display: 'flex',
    },
    containerCenter: {
      display: 'flex',
      alignItems: 'center',
    },
    boxcontainer: {
      display: 'flex',
      width: '100%',
      height: '100%',
    },
    toggleBox: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: '24px',
    },
    infoBox: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: '24px',
      padding: '10PX',
      backgroundColor: '#f0f9ff',
    },
    border: {
      borderStyle: 'solid',
      borderColor: 'red',
    },
  }),
);
export interface PopupImportExportStep3Props {
  title: string;
  backName: string;
  nextName: string;
  cancelName: string;
  rows: number;
  back: () => void;
  next: () => void;
  cancel: () => void;
}
export function PopupImportExportStep3(props: PopupImportExportStep3Props) {
  const classes = useStyles();
  const [toggle1, setToggle1] = React.useState<boolean>(true);
  const handleColumnCheckboxChange = React.useCallback(
    (value: boolean, cn: number) => {
      if (ImprotData.Header !== undefined) {
        ImprotData.Header[cn].Include = value;
      }
    },
    [],
  );
  const handleColumnPickerChange = React.useCallback(
    (value: Entity<string> | null | undefined, cn: number) => {
      if (ImprotData.Header !== undefined) {
        ImprotData.Header[cn].Name = value?.Id;
      }
    },
    [],
  );
  /*const getColumnValue = React.useCallback((column: ImportColumn) => {
    if (column.ExcelName !== undefined) {
      const v = ImprotData.TemplateColumns?.find(value => {
        return value.Name === column.ExcelName;
      });
      return v;
    } else {
      return undefined;
    }
  }, []);*/
  const handleToggleChange1 = React.useCallback((value: boolean) => {
    setToggle1(value);
  }, []);
  return (
    <>
      <Box className={clsx(classes.root)}>
        <Box style={{ height: '2%' }}>
          <Box className={classes.titleContainer}>
            <IconButton
              variant="ghost"
              aria-label="close"
              className={classes.closeButton}
              onClick={props.cancel}
              size="small"
            >
              <Icon icon="times" />
            </IconButton>
            <H3>{props.title}</H3>
          </Box>
        </Box>
        <Box style={{ height: '23%' }} className={clsx(classes.boxcontainer)}>
          <Box style={{ width: '50%' }}>
            <ToggleBox
              rows={props.rows}
              toggle1={toggle1}
              handleToggleChange1={handleToggleChange1}
            />
          </Box>
          <Box style={{ width: '50%' }}>
            <InfoBox />
          </Box>
        </Box>
        <Box style={{ height: '60%' }} className={clsx(classes.boxcontainer)}>
          <BasicTable
            header1={
              ImprotData.Header !== undefined
                ? ImprotData.Header.map((value, cn) => {
                    return (
                      <HeaderColumn
                        checked={value.Include}
                        name={
                          value.ExcelName !== undefined ? value.ExcelName : ''
                        }
                        onChange={handleColumnCheckboxChange}
                        cn={cn}
                      />
                    );
                  })
                : []
            }
            header2={
              ImprotData.Header !== undefined && !toggle1
                ? ImprotData.Header.map((value, cn) => {
                    return (
                      <HeaderColumnPicker
                        names={ImprotData.TemplateColumns}
                        //value={getColumnValue(value)}
                        onChange={handleColumnPickerChange}
                        cn={cn}
                      />
                    );
                  })
                : []
            }
            rows={ImprotData.Table !== undefined ? ImprotData.Table : []}
          />
        </Box>
        <Box style={{ height: '15%', marginTop: '10px' }}>
          <Box
            style={{ height: '50%' }}
            className={clsx(classes.containerCenter)}
          >
            {/*<ValuePicker
              style={{ width: '25%' }}
              value={undefined}
              onChange={() => {}}
              names={undefined}
          />*/}
            {/*<Button style={{ marginLeft: '10px' }} onClick={props.next}>
              {props.nextName}
          </Button>*/}
          </Box>
          <Box
            style={{ height: '50%' }}
            className={clsx(classes.containerCenter)}
          >
            <Button
              variant="white"
              onClick={props.back}
              style={{ marginLeft: '10px', marginRight: '10px' }}
            >
              {props.backName}
            </Button>
            <Button onClick={props.next}>{props.nextName}</Button>
            <Button
              variant="white"
              onClick={props.cancel}
              style={{ marginLeft: '10px' }}
            >
              {props.cancelName}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
}

interface ToggleBoxProps {
  rows: number;
  toggle1: boolean;
  handleToggleChange1: (value: boolean) => void;
}
function ToggleBox(props: ToggleBoxProps) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();
  const [toggle1, setToggle1] = React.useState<boolean>(props.toggle1);
  const [toggle2, setToggle2] = React.useState<boolean>(true);
  const classes = useStyles();
  const rows = React.useMemo((): React.ReactNode => {
    let s = t(translations.RecordsInTheFile);
    s = s.replace('{0}', props.rows.toString());
    return (
      <>
        <div>
          <Body bold={true}> {s} </Body>
        </div>
      </>
    );
  }, [props.rows, t]);
  const handleChange1 = React.useCallback(
    (checked: boolean, event: React.ChangeEvent<HTMLInputElement>) => {
      setToggle1(checked);
      props.handleToggleChange1(checked);
    },
    [props],
  );
  const handleChange2 = React.useCallback(
    (checked: boolean, event: React.ChangeEvent<HTMLInputElement>) => {
      setToggle2(checked);
      ImprotData.AddOnly = !checked;
    },
    [],
  );
  return (
    <Box className={clsx(classes.toggleBox)}>
      <Box style={{ margin: '10px' }}>
        {rows}
        <br />
        <BasicToggle
          name="checkedB"
          onChange={handleChange1}
          defaultChecked={true}
          checked={toggle1}
          label={t(translations.FirstRowContainsColumnsName)}
        />
        <br />
        <BasicToggle
          name="checkedC"
          onChange={handleChange2}
          defaultChecked={true}
          checked={toggle2}
          label={t(translations.UpdateAnyExistingRecords)}
        />
      </Box>
    </Box>
  );
}
interface InfoBoxProps {}
function InfoBox(props: InfoBoxProps) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  return (
    <Box className={clsx(classes.infoBox)} style={{ width: '488px' }}>
      <Box style={{ margin: '10px' }}>
        <li>{t(translations.UncheckColumnIfYouDontWantItToBeImported)}</li>
        <li>{t(translations.OnlyFirst5RowsOfTheFileAreDisplayedForPreview)}</li>
      </Box>
    </Box>
  );
}
